import {Component, ElementRef, HostListener, OnInit, ViewChild, TemplateRef, NgZone, ChangeDetectorRef} from '@angular/core';
import {HeaderService} from "../../../services/header/header.service";
import feather from 'feather-icons';
import {Router} from "@angular/router";
import {EMPTY, forkJoin, Observable, of, Subject, Subscription, throwError} from 'rxjs';
import {catchError, expand, map, reduce, switchMap, take, tap} from 'rxjs/operators';
import {ProductsService} from "../../../services/products/products.service";
import {LogicielCaisseAuthService} from "../../../services/logiciel-caisse/logiciel-caisse-auth.service";
import {
    LogicielCaisseProduitService,
    ProduitItem,
} from "../../../services/logiciel-caisse/logiciel-caisse-produit.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import * as Feather from 'feather-icons';
import {ToastrService} from "ngx-toastr";
import {PaginatedResponse} from "../../../models/paginatedResponse";
import {Client} from "../../../models/client";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import {Product} from "../../../models/Product";
import {Fournisseur} from "../../../models/fournisseur";
import {Tva, TvaService} from "../../parametre/taxe-tva/parametre-tva/tva.service";
import {Taxe, TaxeService} from "../../parametre/taxe-tva/parametre-taxe/taxe.service";
import {CategorieService} from "../../../services/categorie-unite-marque/categorie.service";
import {MarqueService} from "../../../services/categorie-unite-marque/marque.service";
import {UniteService} from "../../../services/categorie-unite-marque/unite.service";
import {Categorie} from "../../../models/categorie";
import {Marque} from "../../../models/marque";
import {Unite} from "../../../models/Unite";
import {getStationIdFromLocalStorage} from "../../../services/parametre-document/parametre-document-state.service";
import { createEmptyProductImportWorkbook } from "../shared/document/document-product-xlsx-import.helper";
import {ParametreDonneesApiService} from "../../parametre/parametre-donnees/parametre-donnees-api.service";
import {ParametreDonneesStateService} from "../../parametre/parametre-donnees/parametre-donnees-state.service";
import {
    DataExportFormatDto,
    DataExportMappingDto,
    resolveRefModuleTableDbId
} from "../../parametre/parametre-donnees/parametre-donnees-api.models";

export interface ProductImportPreviewLine {
    excelLine: number;
    nom: string;
    type: string;
    prix: string;
    ref_interne: string;
    ref_fabricant: string;
    code_barre: string;
    description: string;
    tva: string;
    categorie: string;
    marque: string;
    missingConstraints: string[];
    hasErrors: boolean;
}

export interface ProductImportPreviewGroup {
    reference: string;
    lines: ProductImportPreviewLine[];
    expanded: boolean;
    hasErrors: boolean;
}

@Component({
    selector: 'app-gestionProduits',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {

    @ViewChild('importModal', { static: false }) importModal!: TemplateRef<any>;
    @ViewChild('importPreviewModal', { static: false }) importPreviewModal!: TemplateRef<any>;
    @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

    /** Items du dropdown "Exporter" (formats dynamiques). */
    private exportModelsDropdownItems: any[] = [];

    /** Taille max fichier import produits (.xlsx). */
    private static readonly IMPORT_MAX_BYTES = 50 * 1024 * 1024;

    actifCount: number = 0;
    archivedCount: number = 0;
    selectedFile: File | null = null;
    importPreviewBusy = false;
    importConfirmBusy = false;
    importPreviewGroups: ProductImportPreviewGroup[] = [];
    importPreviewTotalLines = 0;
    importPreviewErrorCount = 0;
    importPreviewValidCount = 0;
    searchText: string = '';
    categories : any [] = [];
    marques : any [] = [];
    tvas : any [] = [];
    taxes : any [] = [];
    public contentHeader: object
    currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
    clientId = this.currentUser?.id;
    stationId = this.currentUser?.stations?.[0]?.id;
    private subscriptions: Subscription[] = [];
    private readonly importTvaLogPrefix = '[Import produits · TVA]';
    syncFromCaisseBusy = false;

    private syncSessionContextFromStorage(): void {
        try {
            const raw = localStorage.getItem('currentUser');
            if (raw == null || raw === '') {
                return;
            }
            const u = JSON.parse(raw) as Record<string, any>;
            this.currentUser = u;
            const uid = u?.id ?? u?.user_id;
            if (uid != null && uid !== '') {
                const n = Number(uid);
                if (Number.isFinite(n)) {
                    this.clientId = n;
                }
            }
            const st = getStationIdFromLocalStorage();
            if (st > 0) {
                this.stationId = st;
            } else {
                const stations = u?.stations;
                const first =
                    Array.isArray(stations) && stations.length > 0 && typeof stations[0] === 'object'
                        ? stations[0]
                        : null;
                const fallback = Number(first?.station_id ?? first?.id ?? u?.station_id);
                if (Number.isFinite(fallback) && fallback > 0) {
                    this.stationId = fallback;
                }
            }
        } catch {
            /* conserver les valeurs d'instance */
        }
    }

    constructor(
        private toastr: ToastrService,
        private modalService: NgbModal,
        private router: Router,
        private zone: NgZone,
        private cd: ChangeDetectorRef,
        private headerService: HeaderService,
        private productService: ProductsService,
        private productsService: ProductsService,
        private tvaService: TvaService,
        private taxeService: TaxeService,
        private categorieService: CategorieService,
        private marqueService: MarqueService,
        private uniteService: UniteService,
        private readonly paramDonneesState: ParametreDonneesStateService,
        private readonly paramDonneesApi: ParametreDonneesApiService,
        private readonly lcAuth: LogicielCaisseAuthService,
        private readonly lcProduit: LogicielCaisseProduitService
    ) {}


    fetchProductCounts(): void {
        const limitForCount = 1; // We only need the total from the metadata

        // 1. Fetch Active Count (isArchive: false)
        const activeCount$ = this.productService.getProductsByStationId(
            this.stationId,
            1,
            limitForCount,
            false
        ).pipe(
            // Extract the total number of items from the response metadata
            map(response => response.meta.total)
        );

        //  Fetch Archive Count (isArchive: true)
        const archivedCount$ = this.productService.getProductsByStationId(
            this.stationId,
            1,
            limitForCount,
            true
        ).pipe(
            // Extract the total number of items from the response metadata
            map(response => response.meta.total)
        );


        forkJoin({
            active: activeCount$,
            archived: archivedCount$
        }).subscribe({
            next: (results) => {

                this.actifCount = results.active;
                this.archivedCount = results.archived;


            },
            error: (err) => {

                // Handle error gracefully (e.g., set counts to 0)
                this.actifCount = 0;
                this.archivedCount = 0;
            }
        });
    }

    ngAfterViewInit(): void {
        //  feather.replace();
    }

    ngOnInit(): void {
        this.syncSessionContextFromStorage();
        this.fetchProductCounts();
        this.loadProducts();
        this.exportModelsDropdownItems = [
            {
                label: 'Chargement…',
                action: () => this.toastr.info('Chargement des modèles d’export…', 'Export')
            }
        ];
        this.applyHeaderConfig();
        this.loadExportModelsForDropdown();

    }

    private applyHeaderConfig(): void {
        this.headerService.setConfig({
            title: 'Produits & Services',
            buttons: [
                {
                    label: 'Exporter',
                    type: 'dropdown',
                    dropdownItems: this.exportModelsDropdownItems
                },
                {
                    label: 'Importer',
                    action: () => this.openImportModal(),
                    type: 'secondary'
                },
                {
                    label: this.syncFromCaisseBusy ? 'Copie caisse…' : 'Copier depuis caisse',
                    action: () => this.copyProductsFromLogicielCaisse(),
                    type: 'secondary'
                }
            ]
        });
    }

    /**
     * Copie les produits logiciel de caisse → ERP.
     * Attributs (couleur, taille, rayon, famille, sous_famille, refs…) inchangés ;
     * les produits déjà présents (même code-barres / ref) ne sont pas écrasés.
     */
    copyProductsFromLogicielCaisse(): void {
        if (this.syncFromCaisseBusy) {
            return;
        }
        this.syncSessionContextFromStorage();
        const stationId = Number(this.stationId);
        const clientId = Number(this.clientId);
        if (!Number.isFinite(stationId) || stationId <= 0 || !Number.isFinite(clientId) || clientId <= 0) {
            this.toastr.error('Utilisateur ou station non valide. Veuillez vous reconnecter.', 'Erreur');
            return;
        }

        this.syncFromCaisseBusy = true;
        this.applyHeaderConfig();

        const sub = this.lcAuth
            .bootstrap()
            .pipe(
                switchMap((status) => {
                    if (status !== 'ready') {
                        return throwError(
                            () =>
                                new Error(
                                    'Session logiciel de caisse non prête. Connectez-vous à la caisse puis réessayez.'
                                )
                        );
                    }
                    return forkJoin([
                        this.fetchAllLcProduits(true),
                        this.fetchAllLcProduits(false),
                    ]);
                }),
                switchMap(([actifs, archives]) => {
                    const products = [...actifs, ...archives];
                    if (products.length === 0) {
                        return of({
                            summary: {
                                received: 0,
                                created: 0,
                                skipped_existing: 0,
                                skipped_invalid: 0,
                            },
                        });
                    }
                    return this.syncLcProductsInChunks(stationId, clientId, products);
                }),
                take(1)
            )
            .subscribe({
                next: (res) => {
                    this.syncFromCaisseBusy = false;
                    this.applyHeaderConfig();
                    const s = res?.summary;
                    const created = s?.created ?? 0;
                    const skipped = s?.skipped_existing ?? 0;
                    const invalid = s?.skipped_invalid ?? 0;
                    const received = s?.received ?? 0;
                    if (created === 0 && received === 0) {
                        this.toastr.info('Aucun produit à copier depuis la caisse.', 'Copie caisse');
                        return;
                    }
                    if (created === 0) {
                        this.toastr.info(
                            `Aucun nouveau produit. ${skipped} déjà présent(s)${
                                invalid ? `, ${invalid} invalide(s)` : ''
                            }.`,
                            'Copie caisse'
                        );
                        return;
                    }
                    this.toastr.success(
                        `${created} produit(s) copié(s). ${skipped} déjà présent(s)${
                            invalid ? `, ${invalid} ignoré(s)` : ''
                        }.`,
                        'Copie caisse'
                    );
                    setTimeout(() => window.location.reload(), 400);
                },
                error: (err) => {
                    this.syncFromCaisseBusy = false;
                    this.applyHeaderConfig();
                    const msg =
                        err?.error?.message ||
                        err?.message ||
                        'Échec de la copie des produits depuis la caisse.';
                    this.toastr.error(String(msg), 'Copie caisse');
                },
            });
        this.subscriptions.push(sub);
    }

    private fetchAllLcProduits(actif: boolean): Observable<ProduitItem[]> {
        const pageSize = 100;
        return this.lcProduit.getProduits({ actif, page: 1, limit: pageSize }).pipe(
            expand((page) => {
                if (page.pagination.page >= page.pagination.totalPages) {
                    return EMPTY;
                }
                return this.lcProduit.getProduits({
                    actif,
                    page: page.pagination.page + 1,
                    limit: pageSize,
                });
            }),
            reduce((acc, page) => acc.concat(page.items || []), [] as ProduitItem[])
        );
    }

    private syncLcProductsInChunks(
        stationId: number,
        clientId: number,
        products: ProduitItem[]
    ): Observable<{
        summary: {
            received: number;
            created: number;
            skipped_existing: number;
            skipped_invalid: number;
        };
    }> {
        const chunkSize = 400;
        const chunks: ProduitItem[][] = [];
        for (let i = 0; i < products.length; i += chunkSize) {
            chunks.push(products.slice(i, i + chunkSize));
        }

        const summary = {
            received: products.length,
            created: 0,
            skipped_existing: 0,
            skipped_invalid: 0,
        };

        const run = (idx: number): Observable<typeof summary> => {
            if (idx >= chunks.length) {
                return of(summary);
            }
            return this.productService.syncFromLogicielCaisse(stationId, clientId, chunks[idx]).pipe(
                switchMap((res) => {
                    const s = res?.summary;
                    summary.created += s?.created ?? 0;
                    summary.skipped_existing += s?.skipped_existing ?? 0;
                    summary.skipped_invalid += s?.skipped_invalid ?? 0;
                    return run(idx + 1);
                })
            );
        };

        return run(0).pipe(map((s) => ({ summary: s })));
    }

    private iconForExportType(type: string): string | undefined {
        const t = String(type || '').toLowerCase().trim();
        if (t === 'pdf') return '../../../assets/images/logo/pdf_logo.png';
        if (t === 'csv') return '../../../assets/images/logo/csv_logo.png';
        if (t === 'xlsx' || t === 'xls') return '../../../assets/images/logo/xlsx_logo.png';
        // Icône par défaut si type inconnu
        return 'assets/images/logo/Fichier 1.png';
    }

    /**
     * Remplace la liste statique (PDF/CSV/XLSX) par la liste des modèles (data_export_format)
     * configurés dans Paramétrage → Export.
     */
    private loadExportModelsForDropdown(): void {
        const ctx = this.getExportContextOrWarn();
        if (!ctx) {
            this.exportModelsDropdownItems = [
                {
                    label: 'Session invalide',
                    action: () => this.toastr.error('Session invalide : station ou utilisateur introuvable.', 'Export')
                }
            ];
            this.applyHeaderConfig();
            return;
        }

        const sub = this.paramDonneesState
            .ensureRefModules()
            .pipe(
                map(() => this.getProduitsRefModuleOrWarn()),
                switchMap((ref) => {
                    if (!ref) {
                        return of([] as DataExportFormatDto[]);
                    }
                    return this.paramDonneesApi.getDataExportFormatsByTable(ref.tableDbId, ctx.stationId, ctx.userId).pipe(
                        catchError(() => of([] as DataExportFormatDto[]))
                    );
                }),
                take(1)
            )
            .subscribe({
                next: (formats) => {
                    // IMPORTANT : ne pas trier ici. L’onglet Paramétrage → Export numérote selon l’ordre
                    // renvoyé par l’API/state. On conserve donc cet ordre pour que "Modèle N" corresponde.
                    const orderedFormats = Array.isArray(formats) ? formats : [];

                    if (orderedFormats.length === 0) {
                        this.exportModelsDropdownItems = [
                            {
                                label: 'Aucun modèle d’export actif',
                                action: () =>
                                    this.toastr.warning(
                                        'Aucun modèle d’export actif n’est configuré. Activez-en un dans Paramétrage → Export.',
                                        'Export'
                                    )
                            }
                        ];
                        this.applyHeaderConfig();
                        return;
                    }

                    this.exportModelsDropdownItems = orderedFormats.map((fmt, idx) => {
                        const exportFormatId = Number((fmt as any)?.id);
                        const type = String((fmt as any)?.type ?? '').toLowerCase().trim();
                        const nom = String((fmt as any)?.nom ?? 'Export').trim() || 'Export';
                        // Affichage aligné sur Paramétrage → Export : "Modèle N(type)"
                        const label = `Modèle ${idx + 1}${type ? `(${type})` : ''}`;
                        const actif = (fmt as any)?.actif === true;
                        return {
                            label,
                            icon: this.iconForExportType(type),
                            action: () => {
                                if (!actif) {
                                    this.toastr.warning('Ce modèle est inactif.', 'Export');
                                    return;
                                }
                                this.exportUsingExportModel(exportFormatId, nom, type);
                            }
                        };
                    });
                    this.applyHeaderConfig();
                },
                error: () => {
                    this.exportModelsDropdownItems = [
                        {
                            label: 'Erreur chargement modèles',
                            action: () =>
                                this.toastr.error('Erreur lors du chargement des modèles d’export.', 'Export')
                        }
                    ];
                    this.applyHeaderConfig();
                }
            });

        this.subscriptions.push(sub);
    }

    private exportUsingExportModel(exportFormatId: number, modelLabel: string, type: string): void {
        const data = this.getProductData();
        if (!data || data.length === 0) {
            this.toastr.warning('Aucune donnée disponible pour l\'exportation', 'Avertissement');
            return;
        }

        const exportType = String(type || '').toLowerCase().trim();
        if (exportType === 'pdf') {
            this.exportToPDF(data);
            return;
        }
        if (exportType === 'csv') {
            this.exportDynamicCsvOrXlsxByFormat(data, 'csv', exportFormatId, modelLabel);
            return;
        }
        if (exportType === 'xlsx' || exportType === 'xls') {
            this.exportDynamicCsvOrXlsxByFormat(data, 'xlsx', exportFormatId, modelLabel);
            return;
        }

        this.toastr.warning(`Type d’export non supporté : ${exportType || 'inconnu'}`, 'Export');
    }

    /**
     * Normalise un libellé de colonne import : espaces, underscores, tirets, accents.
     * Ex. ref_interne → REF INTERNE, code_barre → CODE BARRE.
     */
    private normalizeImportHeaderLabel(h: any): string {
        if (h == null || h === '') {
            return '';
        }
        return String(h)
            .trim()
            .replace(/\u00a0/g, ' ')
            .replace(/_/g, ' ')
            .replace(/-/g, ' ')
            .replace(/\s+/g, ' ')
            .toUpperCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
    }

    /** Compare libellés import (insensible à la casse / accents). */
    private importLabelEquals(a: string, b: string): boolean {
        return this.normalizeImportHeaderLabel(a) === this.normalizeImportHeaderLabel(b);
    }

    /** Équivalent RxJS 7 `firstValueFrom`, compatible RxJS 6. */
    private rxFirst<T>(source: Observable<T>): Promise<T> {
        return source.pipe(take(1)).toPromise() as Promise<T>;
    }

    /**
     * Lit une cellule par clé de headerMap (évite les pièges de cellules numériques Excel vs chaînes vides).
     */
    private readImportCellTrimmed(
        row: any[],
        headerMap: Record<string, number>,
        key: string
    ): string | null {
        const idx = headerMap[key];
        if (idx == null || idx < 0) {
            return null;
        }
        const v = row[idx];
        if (v === undefined || v === null || v === '') {
            return null;
        }
        return String(v).trim();
    }

    /**
     * Valeur TVA saisie dans le fichier (ex. "7", "7%", "7,5", " 19 ") → nombre.
     */
    private parseTvaImportValue(raw: string): number | null {
        const cleaned = String(raw)
            .trim()
            .replace(/%/g, '')
            .replace(/\s/g, '')
            .replace(',', '.');
        if (cleaned === '') {
            return null;
        }
        const n = parseFloat(cleaned);
        return isNaN(n) ? null : n;
    }

    /**
     * Compare la valeur fichier à `t.valeur` renvoyé par GET /api/settings/tva/:station_id
     * (tolérance flottants, formats Excel / %).
     */
    private tvaListeEntryMatchesCell(t: Tva, parsedFile: number | null, rawTrimmed: string): boolean {
        const apiNum = Number(t.valeur);
        if (parsedFile !== null && !isNaN(apiNum)) {
            return Math.abs(apiNum - parsedFile) < 1e-4;
        }
        const norm = (v: unknown) =>
            String(v ?? '')
                .trim()
                .replace(/%/g, '')
                .replace(/\s/g, '')
                .replace(',', '.');
        return norm(t.valeur) === norm(rawTrimmed);
    }

    /** Extrait l'id TVA depuis la réponse GET .../by-valeur (formes possibles selon l’API). */
    private extractTvaIdFromByValeurResponse(res: any): number | null {
        if (res == null || typeof res === 'string') {
            return null;
        }

        const toId = (v: unknown): number | null => {
            if (v == null || v === '') {
                return null;
            }
            const n = Number(v);
            return Number.isFinite(n) && n > 0 ? n : null;
        };

        /**
         * Forme réelle API by-valeur :
         * { "success": true, "tvaListe": [{ "id": 52, "valeur": 19, ... }], "count": 1 }
         * (éventuellement enveloppée dans { data: { ... } } par un intercepteur)
         */
        const envelope = res?.data != null && typeof res.data === 'object' && !Array.isArray(res.data) ? res.data : res;
        if (envelope?.success === true && Array.isArray(envelope.tvaListe) && envelope.tvaListe.length > 0) {
            const first = envelope.tvaListe[0];
            const rid = toId(first?.id);
            if (rid != null) {
                return rid;
            }
        }

        const fromObj = (o: any): number | null => {
            if (!o || typeof o !== 'object') {
                return null;
            }
            return (
                toId(o.id) ??
                toId(o.tva_id) ??
                toId((o as any).ID) ??
                null
            );
        };

        let id = fromObj(res);
        if (id != null) {
            return id;
        }

        id =
            fromObj(res.tva) ??
            fromObj(res.data) ??
            fromObj(res.result) ??
            fromObj(res.payload) ??
            fromObj(res.record);
        if (id != null) {
            return id;
        }

        if (typeof res.tva_id === 'number' || (typeof res.tva_id === 'string' && res.tva_id !== '')) {
            return toId(res.tva_id);
        }

        if (Array.isArray(res)) {
            id = fromObj(res[0]);
            if (id != null) {
                return id;
            }
        }

        const liste = res.tvaListe ?? res.tvas ?? res.data?.tvaListe;
        if (Array.isArray(liste) && liste.length > 0) {
            id = fromObj(liste[0]);
            if (id != null) {
                return id;
            }
        }

        if (res.id != null && (res.valeur !== undefined || res.type !== undefined || res.statut !== undefined)) {
            return toId(res.id);
        }

        const attrId =
            res?.data?.attributes?.id ??
            res?.data?.id ??
            res?.attributes?.id;
        if (attrId != null) {
            return toId(attrId);
        }

        console.warn(
            `${this.importTvaLogPrefix} Impossible d’extraire tva id — structure de réponse non reconnue. Ouvrez la console et copiez « Réponse HTTP 200 brute » pour l’adapter.`,
            res
        );
        return null;
    }

    /**
     * Appel principal pour l’import : GET /api/settings/tva/:station_id/by-valeur?valeur=19
     * → id à mettre dans le payload produit sous `tva_id`.
     */
    private getTvaIdFromByValeurApi(stationId: number, valeurNumeric: number): Observable<number | null> {
        console.info(`${this.importTvaLogPrefix} Requête by-valeur`, {
            stationId,
            valeurQuery: valeurNumeric,
            urlAttendue: `GET .../api/settings/tva/${stationId}/by-valeur?valeur=${valeurNumeric}`
        });
        return this.tvaService.getTvaByValeur(stationId, valeurNumeric).pipe(
            tap((resBrut) =>
                console.info(`${this.importTvaLogPrefix} Réponse HTTP 200 brute (by-valeur)`, resBrut)
            ),
            map((res) => {
                const id = this.extractTvaIdFromByValeurResponse(res);
                console.info(`${this.importTvaLogPrefix} Id extrait après parsing`, {
                    id,
                    extractionOk: id != null && Number(id) > 0
                });
                return id;
            }),
            catchError((err) => {
                console.error(`${this.importTvaLogPrefix} Erreur HTTP by-valeur (404, réseau, CORS, etc.)`, {
                    stationId,
                    valeur: valeurNumeric,
                    status: err?.status,
                    statusText: err?.statusText,
                    message: err?.message,
                    body: err?.error
                });
                return of(null as number | null);
            })
        );
    }

    /**
     * Résolution de l’id TVA pour une ligne d’import :
     * 1) GET /api/settings/tva/:station_id/by-valeur?valeur=&lt;taux&gt;
     * 2) sinon liste en cache (GET liste déjà chargée)
     * 3) en dernier recours POST création TVA
     */
    private resolveImportedProductTvaId(
        raw: string,
        cache: Tva[],
        stationId: number,
        clientId: number
    ): Observable<number> {
        const trimmed = raw.trim();
        const parsedFile = this.parseTvaImportValue(trimmed);

        const lookupFromByValeur$ =
            parsedFile !== null
                ? this.getTvaIdFromByValeurApi(stationId, parsedFile)
                : of(null as number | null);

        return lookupFromByValeur$.pipe(
            switchMap((idFromApi) => {
                const idNum = idFromApi != null ? Number(idFromApi) : NaN;
                if (Number.isFinite(idNum) && idNum > 0) {
                    console.info(`${this.importTvaLogPrefix} Id retenu (source: API by-valeur)`, idNum);
                    return of(idNum);
                }
                const byListe = cache.find((t) =>
                    this.tvaListeEntryMatchesCell(t, parsedFile, trimmed)
                );
                if (byListe?.id != null) {
                    const idCache = Number(byListe.id);
                    console.warn(`${this.importTvaLogPrefix} Id retenu (source: cache liste TVA)`, {
                        idCache,
                        celluleBrute: trimmed,
                        parsedFile,
                        matchValeur: byListe.valeur
                    });
                    return of(idCache);
                }
                console.warn(`${this.importTvaLogPrefix} Aucun id by-valeur ni cache — tentative POST création TVA`, {
                    trimmed,
                    parsedFile,
                    tailleCache: cache.length
                });
                const valeur = parsedFile !== null ? parsedFile : 0;
                const body: Tva = {
                    client_id: clientId,
                    station_id: stationId,
                    valeur,
                    type: '+',
                    restriction: 'Pourcentage',
                    statut: true
                };
                return this.tvaService.createTva(body, stationId).pipe(
                    map((res) => {
                        const t = res?.tva;
                        if (t?.id != null) {
                            cache.push(t);
                            const idCreated = Number(t.id);
                            console.warn(`${this.importTvaLogPrefix} Id retenu (source: POST nouvelle TVA)`, idCreated);
                            return idCreated;
                        }
                        throw new Error('Réponse TVA invalide');
                    })
                );
            })
        );
    }

    private resolveOrCreateTaxeId(
        raw: string,
        cache: Taxe[],
        stationId: number,
        clientId: number
    ): Observable<number> {
        const t = raw.trim();
        const found = cache.find(
            (x) =>
                (x.nom && this.importLabelEquals(x.nom, t)) ||
                (x.label && this.importLabelEquals(x.label, t))
        );
        if (found?.id) {
            return of(found.id);
        }
        const newTaxe: Taxe = {
            id: 0,
            client_id: clientId,
            station_id: stationId,
            nom: t,
            label: t,
            valeur: 0,
            valeur_fixe: false,
            valeur_pourcentage: true,
            applique_avant_tva: false,
            applique_apres_tva: true,
            taxe_applique_sur_produits: true,
            type: '+',
            applique_sur_product: true,
            applique_sur_tous_document: false,
            statut: true
        };
        return this.taxeService.createTaxe(newTaxe, stationId).pipe(
            map((res) => {
                const tx = res?.taxe;
                if (tx?.id) {
                    cache.push(tx);
                    return tx.id;
                }
                throw new Error('Réponse taxe invalide');
            })
        );
    }

    private resolveOrCreateCategorieId(
        raw: string,
        cache: Categorie[],
        stationId: number,
        clientId: number
    ): Observable<number> {
        const lib = raw.trim();
        const found = cache.find((c) => c.libelle && this.importLabelEquals(c.libelle, lib));
        if (found?.id) {
            return of(found.id);
        }
        const cat: Categorie = {
            id: 0,
            user_id: clientId,
            station_id: stationId,
            libelle: lib
        };
        return this.categorieService.addCategorie(cat).pipe(
            map((created) => {
                cache.push(created);
                return created.id;
            })
        );
    }

    private resolveOrCreateMarqueId(
        raw: string,
        cache: Marque[],
        stationId: number,
        clientId: number
    ): Observable<number> {
        const lib = raw.trim();
        const found = cache.find((m) => m.libelle && this.importLabelEquals(m.libelle, lib));
        if (found?.id) {
            return of(found.id);
        }
        const marque: Marque = {
            id: 0,
            user_id: clientId,
            station_id: stationId,
            libelle: lib
        };
        return this.marqueService.addMarque(marque).pipe(
            map((created) => {
                cache.push(created);
                return created.id;
            })
        );
    }

    private resolveOrCreateUniteId(
        raw: string,
        cache: Unite[],
        stationId: number,
        clientId: number
    ): Observable<number> {
        const lib = raw.trim();
        const found = cache.find((u) => u.libelle && this.importLabelEquals(u.libelle, lib));
        if (found?.id) {
            return of(found.id);
        }
        const unite: Unite = {
            id: 0,
            user_id: clientId,
            station_id: stationId,
            libelle: lib
        };
        return this.uniteService.addUnite(unite).pipe(
            map((created) => {
                cache.push(created);
                return created.id;
            })
        );
    }

    /** Retire les champs internes à l’import avant envoi API. */
    private stripProductImportMeta(p: Record<string, any>): Record<string, any> {
        const { __importLine, ...rest } = p;
        return rest;
    }

    private extractBulkImportErrorMessage(err: any): string {
        if (err?.error?.errors && Array.isArray(err.error.errors)) {
            return err.error.errors.map((e: any) => e.message || e).join(', ');
        }
        if (err?.error?.message) {
            return String(err.error.message);
        }
        return err?.message ? String(err.message) : 'Erreur lors de l\'import en masse';
    }

    /** Bulk refusé (souvent tout le lot annulé) à cause d’une contrainte d’unicité. */
    private isLikelyUniquenessConflict(err: any): boolean {
        const status = err?.status;
        if (status === 409 || status === 422) {
            return true;
        }
        const msg = this.extractBulkImportErrorMessage(err).toLowerCase();
        return (
            msg.includes('unicité') ||
            msg.includes('unicite') ||
            msg.includes('duplicate') ||
            (msg.includes('conflit') && (msg.includes('unicité') || msg.includes('unicite') || msg.includes('dupliq')))
        );
    }

    private finishImportWithToast(
        modal: any,
        importedCount: number,
        lineErrors: string[],
        usedSequentialFallback: boolean
    ): void {
        if (importedCount === 0) {
            const em =
                lineErrors.length > 5
                    ? `${lineErrors.slice(0, 5).join('<br>')}<br>... et ${lineErrors.length - 5} autres erreurs`
                    : lineErrors.join('<br>');
            this.toastr.error(
                em || 'Aucun produit importé.',
                'Erreur d\'import',
                //{ enableHtml: lineErrors.length > 0, timeOut: 12000 }
            );
            this.importConfirmBusy = false;
            modal.dismiss('Error');
            return;
        }

        if (lineErrors.length > 0) {
            const errorMessage =
                lineErrors.length > 5
                    ? `${lineErrors.slice(0, 5).join('<br>')}<br>... et ${lineErrors.length - 5} autres erreurs`
                    : lineErrors.join('<br>');
            const title = usedSequentialFallback
                ? `${importedCount} importé(s), ${lineErrors.length} ligne(s) en erreur`
                : `${importedCount} produit(s) importé(s) avec ${lineErrors.length} erreur(s)`;
            this.toastr.warning(errorMessage, title, { enableHtml: true, timeOut: 12000 });
        } else {
            this.toastr.success(`${importedCount} produit(s) importé(s) avec succès`, 'Import réussi');
        }

        this.importConfirmBusy = false;
        this.selectedFile = null;
        if (this.fileInput?.nativeElement) {
            this.fileInput.nativeElement.value = '';
        }
        modal.dismiss('Completed');
        setTimeout(() => window.location.reload(), 300);
    }

    /**
     * Si le bulk échoue pour unicité (ex. code-barres déjà en base), import ligne par ligne :
     * les lignes valides passent, les doublons / conflits sont listés.
     */
    private importProductsSequentialFallback(
        productsWithMeta: Array<Record<string, any>>,
        initialErrors: string[],
        modal: any
    ): void {
        const stationNum = Number(this.stationId);
        const allErrors = [...initialErrors];
        let successCount = 0;

        const step = (idx: number) => {
            if (idx >= productsWithMeta.length) {
                this.finishImportWithToast(modal, successCount, allErrors, true);
                return;
            }
            const row = productsWithMeta[idx];
            const line = row.__importLine ?? idx + 2;
            const body = this.stripProductImportMeta(row);

            this.productService.addProduct(stationNum, body).subscribe({
                next: () => {
                    successCount++;
                    step(idx + 1);
                },
                error: (err) => {
                    allErrors.push(`Ligne ${line} : ${this.extractBulkImportErrorMessage(err)}`);
                    step(idx + 1);
                }
            });
        };

        step(0);
    }

    importFile(modal: any) {
        if (!this.selectedFile) {
            this.toastr.error('Aucun fichier sélectionné', 'Erreur');
            return;
        }

        this.syncSessionContextFromStorage();
        if (!this.stationId || !this.clientId) {
            this.toastr.error('Utilisateur ou station non valide. Veuillez vous reconnecter.', 'Erreur');
            return;
        }

        this.importPreviewBusy = true;
        const reader = new FileReader();
        reader.onload = (e: any) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const firstSheet = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheet];
                const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                const built = this.buildImportPreviewFromSheet(jsonData);
                if (built.error) {
                    this.toastr.error(built.error, 'Erreur');
                    this.importPreviewBusy = false;
                    return;
                }

                this.importPreviewGroups = built.groups;
                this.importPreviewTotalLines = built.totalLines;
                this.importPreviewErrorCount = built.errorCount;
                this.importPreviewValidCount = built.validCount;
                this.importPreviewBusy = false;

                modal.dismiss('preview');
                this.modalService.open(this.importPreviewModal, {
                    backdrop: 'static',
                    keyboard: true,
                    windowClass: 'products-import-preview-window',
                    scrollable: true
                });
                setTimeout(() => feather.replace(), 0);
            } catch (err) {
                console.error(err);
                this.importPreviewBusy = false;
                this.toastr.error('Erreur lors de l\'analyse du fichier', 'Erreur');
            }
        };
        reader.onerror = () => {
            this.importPreviewBusy = false;
            this.toastr.error('Erreur de lecture du fichier', 'Erreur');
        };
        reader.readAsArrayBuffer(this.selectedFile);
    }

    toggleImportPreviewGroup(group: ProductImportPreviewGroup): void {
        group.expanded = !group.expanded;
        setTimeout(() => feather.replace(), 0);
    }

    trackImportPreviewGroup(_: number, g: ProductImportPreviewGroup): string {
        return g.reference;
    }

    trackImportPreviewLine(_: number, line: ProductImportPreviewLine): number {
        return line.excelLine;
    }

    confirmImportPreview(modal: any): void {
        if (!this.selectedFile || this.importConfirmBusy) {
            return;
        }
        this.importConfirmBusy = true;
        this.runProductImport(modal);
    }

    /**
     * Import réel (bulk) après validation de l'aperçu.
     */
    private runProductImport(modal: any) {
        if (!this.selectedFile) {
            this.toastr.error('Aucun fichier sélectionné', 'Erreur');
            this.importConfirmBusy = false;
            modal.dismiss('No file');
            return;
        }

        this.syncSessionContextFromStorage();

        if (!this.stationId || !this.clientId) {
            this.toastr.error('Utilisateur ou station non valide. Veuillez vous reconnecter.', 'Erreur');
            this.importConfirmBusy = false;
            modal.dismiss('Invalid user');
            return;
        }

        try {
            const reader = new FileReader();
            reader.onload = (e: any) => {
                try {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    const firstSheet = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[firstSheet];
                    const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                    const rawHeaders = jsonData[0] ?? [];
                    const headers = rawHeaders.map((h: any) => this.normalizeImportHeaderLabel(h));

                    /** Première colonne dont le libellé normalisé correspond à l’un des alias. */
                    const resolveHeaderIndex = (aliases: string[]): number => {
                        const normalizedAliases = aliases
                            .map(a => this.normalizeImportHeaderLabel(a))
                            .filter(a => a.length > 0);
                        for (let i = 0; i < headers.length; i++) {
                            const cellH = headers[i];
                            if (cellH && normalizedAliases.includes(cellH)) {
                                return i;
                            }
                        }
                        return -1;
                    };

                    const idxNom = resolveHeaderIndex([
                        'DES ART',
                        'DES_ART',
                        'NOM',
                        'NAME',
                        'NOM DU PRODUIT',
                        'LIBELLE',
                        'DESIGNATION'
                    ]);
                    const idxType = resolveHeaderIndex(['TYPE']);
                    const idxPrix = resolveHeaderIndex([
                        'VENTE TTC',
                        'PRIX VENTE',
                        'PRIX DE VENTE',
                        'PRIX_VENTE',
                        'PRIX UNITAIRE',
                        'PRIX',
                        'PRIX_UNITAIRE',
                        'PRIXUNITAIRE',
                        'PU'
                    ]);
                    const idxCodeArt = resolveHeaderIndex(['CODE ART', 'CODE_ART', 'CODE ARTICLE']);
                    const idxArtParent = resolveHeaderIndex(['ART PARENT', 'ART_PARENT']);
                    const idxRefInt = resolveHeaderIndex([
                        'RÉFÉRENCE INTERNE',
                        'REFERENCE INTERNE',
                        'REF INTERNE',
                        'REF_INTERNE',
                        'REF. INTERNE',
                        'REF PRODUIT',
                        'CODE ART',
                        'CODE_ART',
                        'CODE ARTICLE'
                    ]);
                    /** Optionnel : fichiers sans colonne description acceptés. */
                    const idxDesc = resolveHeaderIndex(['DESCRIPTION', 'DESCR', 'DETAILS', 'DETAIL']);
                    const idxResultTtc = resolveHeaderIndex([
                        'RESULT TTC',
                        'RESULTAT TTC',
                        'RESULT_TTC',
                        'RESULT-TTC',
                        'PRIX TTC',
                        'RESULT T.T.C',
                        'VENTE TTC'
                    ]);
                    const idxResultHt = resolveHeaderIndex([
                        'RESULT HT',
                        'RESULTAT HT',
                        'RESULT_HT',
                        'RESULT-HT',
                        'PRIX HT',
                        'RESULT H.T',
                        'ACHAT HT',
                        'VENTE HT'
                    ]);

                    const missingLabels: string[] = [];
                    if (idxNom < 0) {
                        missingLabels.push('DES_ART (ou NOM)');
                    }
                    if (missingLabels.length > 0) {
                        this.toastr.error(
                            'Colonnes obligatoires manquantes : ' + missingLabels.join(', ') +
                                '. Ex. attendu (caisse) : DES_ART, CODE_ART, ART_PARENT, GENC, vente ttc.',
                            'Erreur'
                        );
                        this.importConfirmBusy = false;
                        modal.dismiss('Invalid headers');
                        return;
                    }

                    const headerMap: Record<string, number> = {
                        nom: idxNom,
                        type: idxType,
                        prix: idxPrix >= 0 ? idxPrix : idxResultTtc,
                        ref_interne: idxRefInt >= 0 ? idxRefInt : idxCodeArt,
                        code_art: idxCodeArt,
                        art_parent: idxArtParent,
                        description: idxDesc,
                        result_ttc: idxResultTtc,
                        result_ht: idxResultHt,
                        ref_fabricant: resolveHeaderIndex([
                            'RÉFÉRENCE FABRICANT',
                            'REFERENCE FABRICANT',
                            'RÉFÉRENCE FABRIQUANT',
                            'REFERENCE FABRIQUANT',
                            'REF FABRICANT',
                            'REF FABRIQUANT',
                            'REF_FABRICANT',
                            'REF_FABRIQUANT',
                            'ART PARENT',
                            'ART_PARENT'
                        ]),
                        code_barre: resolveHeaderIndex([
                            'GENC',
                            'CODE BARRE',
                            'CODE_BARRE',
                            'CODE-BARRE',
                            'CODEBARRE',
                            'EAN',
                            'GTIN'
                        ]),
                        couleur: resolveHeaderIndex(['COULEUR']),
                        taille: resolveHeaderIndex(['TAILLE']),
                        rayon: resolveHeaderIndex(['RAYON']),
                        famille: resolveHeaderIndex(['FAMILLE']),
                        sous_famille: resolveHeaderIndex(['SOUS FAMILLE', 'SOUS_FAMILLE', 'SOUS-FAMILLE', 'SOUS FAMILLE']),
                        tva: resolveHeaderIndex([
                            'TVA VENTE',
                            'TVA',
                            'TAUX TVA',
                            'TAUX DE TVA',
                            'TAUX',
                            'POURCENTAGE TVA',
                            'VALEUR TVA',
                            'TVA %',
                            '% TVA',
                            'TAUX T V A'
                        ]),
                        taxe: resolveHeaderIndex(['TAXE', 'TAXES']),
                        marque: resolveHeaderIndex(['MARQUE']),
                        categorie: resolveHeaderIndex([
                            'CATEGORIE',
                            'CATÉGORIE',
                            'CATEGORY',
                            'CATEGORIE PRODUIT'
                        ]),
                        unite: resolveHeaderIndex(['UNITE', 'UNITÉ', 'UNIT', 'UNITÉ DE VENTE', 'UNITE VENTE'])
                    };
                    for (let p = 1; p <= 12; p++) {
                        headerMap[`param${p}`] = resolveHeaderIndex([`PARAM${p}`]);
                    }

                    const errors: string[] = [];

                    const dataRows = jsonData.slice(1).filter(row => row.some((cell: any) => cell != null && cell !== ''));

                    if (dataRows.length === 0) {
                        this.toastr.error('Aucune donnée trouvée dans le fichier', 'Erreur');
                        this.selectedFile = null;
                        if (this.fileInput?.nativeElement) {
                            this.fileInput.nativeElement.value = '';
                        }
                        this.importConfirmBusy = false;
                        modal.dismiss('Empty rows');
                        return;
                    }

                    const stationIdNum = Number(this.stationId);
                    const clientIdNum = Number(this.clientId);

                    forkJoin({
                        tvaListe: this.tvaService.getTvaList(stationIdNum).pipe(
                            map((r) => r?.tvaListe || []),
                            catchError(() => of([] as Tva[]))
                        ),
                        taxes: this.taxeService.getTaxeList(stationIdNum).pipe(
                            map((r: any) => r?.taxes || []),
                            catchError(() => of([] as Taxe[]))
                        ),
                        categories: this.categorieService.getCategoriePerStation(stationIdNum).pipe(
                            catchError(() => of([] as Categorie[]))
                        ),
                        marques: this.marqueService.getMarquePerStation(stationIdNum).pipe(
                            catchError(() => of([] as Marque[]))
                        ),
                        unites: this.uniteService.getUnitePerStation(stationIdNum).pipe(
                            catchError(() => of([] as Unite[]))
                        )
                    }).subscribe({
                        next: async (refs) => {
                            const tvaCache = [...refs.tvaListe];
                            const taxeCache = [...refs.taxes];
                            const catCache = [...refs.categories];
                            const marqueCache = [...refs.marques];
                            const uniteCache = [...refs.unites];

                            const seenCodeBarres = new Set<string>();
                            const seenRefInternes = new Set<string>();

                            const productsToImport: any[] = [];

                            for (let i = 0; i < dataRows.length; i++) {
                                const row = dataRows[i];

                                const cellStr = (key: string): string | null => {
                                    const idx = headerMap[key];
                                    if (idx == null || idx < 0 || row[idx] == null || row[idx] === '') {
                                        return null;
                                    }
                                    return row[idx].toString().trim();
                                };

                                const cellNum = (key: string): number | null => {
                                    const s = cellStr(key);
                                    if (s == null || s === '') {
                                        return null;
                                    }
                                    const n = parseFloat(s.replace(',', '.'));
                                    return isNaN(n) ? null : n;
                                };

                                const nom =
                                    row[headerMap.nom] != null ? row[headerMap.nom].toString().trim() : '';
                                const type =
                                    row[headerMap.type] != null
                                        ? row[headerMap.type].toString().trim().toLowerCase()
                                        : 'matériel';
                                const prix_unitaire =
                                    row[headerMap.prix] != null
                                        ? parseFloat(row[headerMap.prix].toString().replace(',', '.'))
                                        : 0;
                                const ref_interne =
                                    row[headerMap.ref_interne] != null
                                        ? row[headerMap.ref_interne].toString().trim()
                                        : '';
                                const description =
                                    headerMap.description >= 0 && row[headerMap.description] != null
                                        ? row[headerMap.description].toString().trim()
                                        : null;

                                if (!nom) {
                                    errors.push(`Ligne ${i + 2} : Le nom est obligatoire`);
                                    continue;
                                }

                                if (ref_interne && seenRefInternes.has(ref_interne)) {
                                    errors.push(
                                        `Ligne ${i + 2} : réf. interne « ${ref_interne} » en double dans le fichier — ligne ignorée`
                                    );
                                    continue;
                                }
                                if (ref_interne) {
                                    seenRefInternes.add(ref_interne);
                                }

                                const cbDup = cellStr('code_barre');
                                if (cbDup) {
                                    const ck = cbDup.trim();
                                    if (seenCodeBarres.has(ck)) {
                                        errors.push(
                                            `Ligne ${i + 2} : code-barres « ${ck} » en double dans le fichier — ligne ignorée`
                                        );
                                        continue;
                                    }
                                    seenCodeBarres.add(ck);
                                }

                                const resultTtc = cellNum('result_ttc');
                                const resultHt = cellNum('result_ht');

                                try {
                                    if (i === 0) {
                                        console.info(`${this.importTvaLogPrefix} 1ère ligne import`, {
                                            indexColonneTva: headerMap['tva'],
                                            colonneTvaDetectee: headerMap['tva'] != null && headerMap['tva'] >= 0,
                                            echantillonHeaders: Object.keys(headerMap).filter((k) => headerMap[k] >= 0)
                                        });
                                    }

                                    const product: Record<string, any> = {
                                        type: type,
                                        nom: nom,
                                        station_id: this.stationId,
                                        client_id: this.clientId,
                                        ...(prix_unitaire > 0 && { prix_unitaires: prix_unitaire }),
                                        ...(ref_interne && { ref_interne: ref_interne }),
                                        ...(cellStr('ref_fabricant') && {
                                            ref_fabricant: cellStr('ref_fabricant')
                                        }),
                                        ...(description && { description: description }),
                                        ...(cellStr('code_barre') && { code_barre: cellStr('code_barre') }),
                                        ...(cellStr('couleur') && { couleur: cellStr('couleur') }),
                                        ...(cellStr('taille') && { taille: cellStr('taille') }),
                                        ...(cellStr('rayon') && { rayon: cellStr('rayon') }),
                                        ...(cellStr('famille') && { famille: cellStr('famille') }),
                                        ...(cellStr('sous_famille') && {
                                            sous_famille: cellStr('sous_famille')
                                        }),
                                        ...(resultTtc != null && { result_ttc: resultTtc }),
                                        ...(resultHt != null && { result_ht: resultHt })
                                    };

                                    const tvaCell = this.readImportCellTrimmed(row, headerMap, 'tva');
                                    if (tvaCell != null && tvaCell !== '') {
                                        console.info(`${this.importTvaLogPrefix} Ligne ${i + 2} — cellule TVA lue`, {
                                            tvaCell,
                                            parseTvaImportValue: this.parseTvaImportValue(tvaCell)
                                        });
                                        const idTva = await this.rxFirst(
                                            this.resolveImportedProductTvaId(
                                                tvaCell,
                                                tvaCache,
                                                stationIdNum,
                                                clientIdNum
                                            )
                                        );
                                        const idNum = Number(idTva);
                                        if (!Number.isFinite(idNum) || idNum <= 0) {
                                            throw new Error(
                                                `TVA non résolue pour « ${tvaCell} » (vérifiez la valeur et l’API by-valeur).`
                                            );
                                        }
                                        product.tva_id = idNum;
                                        console.info(`${this.importTvaLogPrefix} Ligne ${i + 2} — product.tva_id assigné`, {
                                            tva_id: product.tva_id,
                                            nom: product.nom
                                        });
                                    } else if (headerMap['tva'] != null && headerMap['tva'] >= 0) {
                                        console.warn(`${this.importTvaLogPrefix} Ligne ${i + 2} — colonne TVA présente mais cellule vide`, {
                                            nom: product.nom
                                        });
                                    } else if (i === 0) {
                                        console.warn(
                                            `${this.importTvaLogPrefix} Aucune colonne TVA reconnue dans les en-têtes — tva_id ne sera pas renseigné. Ajoutez une colonne « TVA » ou « TAUX TVA ».`
                                        );
                                    }
                                    if (cellStr('taxe')) {
                                        product.taxe_id = await this.rxFirst(
                                            this.resolveOrCreateTaxeId(
                                                cellStr('taxe')!,
                                                taxeCache,
                                                stationIdNum,
                                                clientIdNum
                                            )
                                        );
                                    }
                                    if (cellStr('categorie')) {
                                        product.categories_id = await this.rxFirst(
                                            this.resolveOrCreateCategorieId(
                                                cellStr('categorie')!,
                                                catCache,
                                                stationIdNum,
                                                clientIdNum
                                            )
                                        );
                                    }
                                    if (cellStr('marque')) {
                                        product.marque_id = await this.rxFirst(
                                            this.resolveOrCreateMarqueId(
                                                cellStr('marque')!,
                                                marqueCache,
                                                stationIdNum,
                                                clientIdNum
                                            )
                                        );
                                    }
                                    if (cellStr('unite')) {
                                        product.unite_id = await this.rxFirst(
                                            this.resolveOrCreateUniteId(
                                                cellStr('unite')!,
                                                uniteCache,
                                                stationIdNum,
                                                clientIdNum
                                            )
                                        );
                                    }

                                    for (let p = 1; p <= 12; p++) {
                                        const pk = `param${p}`;
                                        const pv = cellStr(pk);
                                        if (pv) {
                                            product[pk] = pv;
                                        }
                                    }

                                    this.applyImportProductApiShape(product);

                                    if (i === 0) {
                                        console.info(`${this.importTvaLogPrefix} Payload aligné API (1ère ligne)`, {
                                            tva_id: product.tva_id,
                                            taxes: product.taxes,
                                            liste_prix: product.liste_prix,
                                            information_logistique: product.information_logistique
                                        });
                                    }

                                    product.__importLine = i + 2;
                                    productsToImport.push(product);
                                } catch (rowErr: any) {
                                    errors.push(
                                        `Ligne ${i + 2} : ${rowErr?.message || String(rowErr)}`
                                    );
                                }
                            }

                            if (productsToImport.length === 0) {
                                this.toastr.error('Aucun produit valide à importer', 'Erreur');
                                this.importConfirmBusy = false;
                                modal.dismiss('No valid products');
                                return;
                            }

                            const payloadBulk = productsToImport.map((p) =>
                                this.stripProductImportMeta(p)
                            );

                            console.info(`${this.importTvaLogPrefix} Payload bulk — aperçu tva_id (max 5 lignes)`, 
                                payloadBulk.slice(0, 5).map((p, idx) => ({
                                    index: idx,
                                    nom: p.nom,
                                    tva_id: p.tva_id,
                                    hasTvaKey: Object.prototype.hasOwnProperty.call(p, 'tva_id')
                                }))
                            );
                            const sansTva = payloadBulk.filter(
                                (p) => p.tva_id == null || p.tva_id === '' || Number.isNaN(Number(p.tva_id))
                            );
                            if (sansTva.length > 0) {
                                console.warn(
                                    `${this.importTvaLogPrefix} Produits sans tva_id valide avant envoi API`,
                                    sansTva.length,
                                    sansTva.slice(0, 3).map((p) => ({ nom: p.nom, tva_id: p.tva_id }))
                                );
                            }

                            this.productService.bulkAddProducts(payloadBulk).subscribe({
                                next: () => {
                                    this.importConfirmBusy = false;
                                    this.finishImportWithToast(
                                        modal,
                                        productsToImport.length,
                                        errors,
                                        false
                                    );
                                },
                                error: (error) => {
                                    console.error('Bulk import error:', error);
                                    if (this.isLikelyUniquenessConflict(error)) {
                                        this.importProductsSequentialFallback(
                                            productsToImport,
                                            errors,
                                            modal
                                        );
                                    } else {
                                        this.importConfirmBusy = false;
                                        const errorMessage = this.extractBulkImportErrorMessage(error);
                                        this.toastr.error(errorMessage, 'Erreur d\'import');
                                        modal.dismiss('Error');
                                    }
                                }
                            });
                        },
                        error: () => {
                            this.importConfirmBusy = false;
                            this.toastr.error(
                                'Impossible de charger les référentiels (TVA, taxes, catégories, marques, unités).',
                                'Erreur'
                            );
                            modal.dismiss('Error');
                        }
                    });

                } catch (error) {
                    console.error('Erreur lors du traitement du fichier:', error);
                    this.importConfirmBusy = false;
                    this.toastr.error('Erreur lors du traitement du fichier', 'Erreur');
                    modal.dismiss('Error');
                }
            };

            reader.onerror = () => {
                this.importConfirmBusy = false;
                this.toastr.error('Erreur de lecture du fichier', 'Erreur');
                modal.dismiss('Error');
            };

            reader.readAsArrayBuffer(this.selectedFile);
        } catch (error) {
            console.error('Erreur lors de la lecture du fichier:', error);
            this.importConfirmBusy = false;
            this.toastr.error('Erreur lors de la lecture du fichier', 'Erreur');
            modal.dismiss('Error');
        }
    }

    /**
     * Construit l'aperçu groupé par référence interne + détection des contraintes manquantes.
     */
    private buildImportPreviewFromSheet(jsonData: any[]): {
        groups: ProductImportPreviewGroup[];
        totalLines: number;
        errorCount: number;
        validCount: number;
        error?: string;
    } {
        const rawHeaders = jsonData[0] ?? [];
        const headers = rawHeaders.map((h: any) => this.normalizeImportHeaderLabel(h));
        const resolveHeaderIndex = (aliases: string[]): number => {
            const normalizedAliases = aliases
                .map((a) => this.normalizeImportHeaderLabel(a))
                .filter((a) => a.length > 0);
            for (let i = 0; i < headers.length; i++) {
                const cellH = headers[i];
                if (cellH && normalizedAliases.includes(cellH)) {
                    return i;
                }
            }
            return -1;
        };

        const idxNom = resolveHeaderIndex([
            'DES ART',
            'DES_ART',
            'NOM',
            'NAME',
            'NOM DU PRODUIT',
            'LIBELLE',
            'DESIGNATION'
        ]);
        const idxType = resolveHeaderIndex(['TYPE']);
        const idxPrix = resolveHeaderIndex([
            'VENTE TTC',
            'PRIX VENTE',
            'PRIX DE VENTE',
            'PRIX_VENTE',
            'PRIX UNITAIRE',
            'PRIX',
            'PRIX_UNITAIRE',
            'PRIXUNITAIRE',
            'PU'
        ]);
        const idxCodeArt = resolveHeaderIndex(['CODE ART', 'CODE_ART', 'CODE ARTICLE']);
        const idxArtParent = resolveHeaderIndex(['ART PARENT', 'ART_PARENT']);
        const idxRefInt = resolveHeaderIndex([
            'RÉFÉRENCE INTERNE',
            'REFERENCE INTERNE',
            'REF INTERNE',
            'REF_INTERNE',
            'REF. INTERNE',
            'REF PRODUIT',
            'CODE ART',
            'CODE_ART',
            'CODE ARTICLE'
        ]);

        const missingLabels: string[] = [];
        if (idxNom < 0) missingLabels.push('DES_ART (ou NOM)');
        if (missingLabels.length > 0) {
            return {
                groups: [],
                totalLines: 0,
                errorCount: 0,
                validCount: 0,
                error:
                    'Colonnes obligatoires manquantes : ' +
                    missingLabels.join(', ') +
                    '. Ex. attendu (caisse) : DES_ART, CODE_ART, ART_PARENT, GENC, vente ttc.'
            };
        }

        const idx = {
            nom: idxNom,
            type: idxType,
            prix: idxPrix,
            ref_interne: idxRefInt >= 0 ? idxRefInt : idxCodeArt,
            code_art: idxCodeArt,
            art_parent: idxArtParent,
            ref_fabricant: resolveHeaderIndex([
                'RÉFÉRENCE FABRICANT',
                'REFERENCE FABRICANT',
                'RÉFÉRENCE FABRIQUANT',
                'REFERENCE FABRIQUANT',
                'REF FABRICANT',
                'REF FABRIQUANT',
                'REF_FABRICANT',
                'REF_FABRIQUANT',
                'ART PARENT',
                'ART_PARENT'
            ]),
            code_barre: resolveHeaderIndex([
                'GENC',
                'CODE BARRE',
                'CODE_BARRE',
                'CODE-BARRE',
                'CODEBARRE',
                'EAN',
                'GTIN'
            ]),
            description: resolveHeaderIndex(['DESCRIPTION', 'DESCR', 'DETAILS', 'DETAIL']),
            tva: resolveHeaderIndex([
                'TVA VENTE',
                'TVA',
                'TAUX TVA',
                'TAUX DE TVA',
                'TAUX',
                'POURCENTAGE TVA',
                'VALEUR TVA',
                'TVA %',
                '% TVA',
                'TAUX T V A'
            ]),
            categorie: resolveHeaderIndex([
                'CATEGORIE',
                'CATÉGORIE',
                'CATEGORY',
                'CATEGORIE PRODUIT',
                'FAMILLE'
            ]),
            marque: resolveHeaderIndex(['MARQUE']),
            famille: resolveHeaderIndex(['FAMILLE'])
        };

        const cellAt = (row: any[], col: number): string => {
            if (col < 0 || row[col] == null || row[col] === '') {
                return '';
            }
            return String(row[col]).trim();
        };

        const dataRows = jsonData
            .slice(1)
            .map((row, i) => ({ row, excelLine: i + 2 }))
            .filter(({ row }) => Array.isArray(row) && row.some((cell: any) => cell != null && cell !== ''));

        if (dataRows.length === 0) {
            return {
                groups: [],
                totalLines: 0,
                errorCount: 0,
                validCount: 0,
                error: 'Aucune donnée trouvée dans le fichier'
            };
        }

        const cbCounts = new Map<string, number>();
        for (const { row } of dataRows) {
            const cb = cellAt(row, idx.code_barre);
            if (cb) {
                cbCounts.set(cb, (cbCounts.get(cb) || 0) + 1);
            }
        }

        const lines: ProductImportPreviewLine[] = dataRows.map(({ row, excelLine }) => {
            const nom = cellAt(row, idx.nom);
            const type = cellAt(row, idx.type);
            const prixRaw = cellAt(row, idx.prix);
            const ref_interne = cellAt(row, idx.ref_interne);
            const ref_fabricant = cellAt(row, idx.ref_fabricant);
            const code_barre = cellAt(row, idx.code_barre);
            const description = cellAt(row, idx.description);
            const tva = cellAt(row, idx.tva);
            const categorie = cellAt(row, idx.categorie);
            const marque = cellAt(row, idx.marque);

            const missingConstraints: string[] = [];
            if (!nom) missingConstraints.push('Nom obligatoire');
            if (!type) missingConstraints.push('Type obligatoire');
            if (!ref_interne) missingConstraints.push('Référence interne obligatoire');
            if (!prixRaw) {
                missingConstraints.push('Prix unitaire obligatoire');
            } else {
                const n = parseFloat(prixRaw.replace(',', '.'));
                if (Number.isNaN(n)) {
                    missingConstraints.push('Prix unitaire invalide');
                }
            }
            if (code_barre && (cbCounts.get(code_barre) || 0) > 1) {
                missingConstraints.push(`Code-barres « ${code_barre} » en double dans le fichier`);
            }

            return {
                excelLine,
                nom,
                type,
                prix: prixRaw,
                ref_interne,
                ref_fabricant,
                code_barre,
                description,
                tva,
                categorie,
                marque,
                missingConstraints,
                hasErrors: missingConstraints.length > 0
            };
        });

        const groupMap = new Map<string, ProductImportPreviewLine[]>();
        for (const line of lines) {
            const key = line.ref_interne || 'Sans référence';
            const list = groupMap.get(key) ?? [];
            list.push(line);
            groupMap.set(key, list);
        }

        const groups: ProductImportPreviewGroup[] = Array.from(groupMap.entries()).map(
            ([reference, groupLines]) => {
                const hasErrors = groupLines.some((l) => l.hasErrors);
                return {
                    reference,
                    lines: groupLines,
                    expanded: hasErrors,
                    hasErrors
                };
            }
        );

        // Groupes en erreur d'abord, puis alpha
        groups.sort((a, b) => {
            if (a.hasErrors !== b.hasErrors) {
                return a.hasErrors ? -1 : 1;
            }
            return a.reference.localeCompare(b.reference, 'fr');
        });

        const errorCount = lines.filter((l) => l.hasErrors).length;
        return {
            groups,
            totalLines: lines.length,
            errorCount,
            validCount: lines.length - errorCount
        };
    }

    /**
     * Même schéma que `add-product` → `preparePriceLists()` (validation API bulk).
     * `prix_id` ≠ 0 ; `bascul_calcul` ∈ prix_public | arbitraires ; `regles` ∈ fixe | pourcentage.
     */
    private preparePriceListsForImport(prix_ht: number, prix_ttc: number): any {
        const clientId = Number(this.clientId);
        const stationId = Number(
            this.stationId ??
                this.currentUser?.stations?.[0]?.station_id ??
                this.currentUser?.stations?.[0]?.id
        );
        return {
            prix_id: 1,
            bascul_calcul: 'prix_public',
            regles: 'fixe',
            montant: Number(prix_ht),
            result_ttc: Number(prix_ttc),
            result_ht: Number(prix_ht),
            client_id: clientId,
            station_id: stationId
        };
    }

    /** Comme `add-product` → `prepareWarehouses()` : client_id + station_id requis sur chaque ligne. */
    private prepareWarehousesForImport(stock_minimum: number, stock_maximum: number): any[] {
        const clientId = Number(this.clientId);
        const stationId = Number(
            this.stationId ??
                this.currentUser?.stations?.[0]?.station_id ??
                this.currentUser?.stations?.[0]?.id
        );
        return [
            {
                entrepot_id: 1,
                minimum: stock_minimum,
                maximum: stock_maximum,
                is_active_alert: stock_minimum > 0,
                client_id: clientId,
                station_id: stationId
            }
        ];
    }

    /**
     * Aligne chaque ligne importée sur le même schéma que la fiche « ajouter produit » / POST produit
     * (sinon l’API bulk peut enregistrer tva_id à null même si envoyé).
     */
    private applyImportProductApiShape(product: Record<string, any>): void {
        const tid = product.tva_id;
        if (tid != null && tid !== '' && !Number.isNaN(Number(tid))) {
            product.tva_id = Math.floor(Number(tid));
        }

        if (!Array.isArray(product.taxes)) {
            const tx = product.taxe_id;
            if (tx != null && Number(tx) > 0) {
                product.taxes = [
                    {
                        taxe_id: Number(tx),
                        client_id: product.client_id,
                        station_id: product.station_id
                    }
                ];
            } else {
                product.taxes = [];
            }
        }

        if (!Array.isArray(product.liste_prix) || product.liste_prix.length === 0) {
            const pu = Number(product.prix_unitaires ?? 0);
            const rht = product.result_ht != null ? Number(product.result_ht) : null;
            const rtc = product.result_ttc != null ? Number(product.result_ttc) : null;
            if (pu > 0 || (rht != null && !Number.isNaN(rht)) || (rtc != null && !Number.isNaN(rtc))) {
                const ht = rht != null && !Number.isNaN(rht) ? rht : pu;
                const ttc =
                    rtc != null && !Number.isNaN(rtc) ? rtc : pu > 0 ? pu : ht;
                product.liste_prix = [this.preparePriceListsForImport(ht, ttc)];
            } else if (product.tva_id != null && Number(product.tva_id) > 0) {
                const ht = Number(product.result_ht ?? 0);
                const ttc = Number(product.result_ttc ?? ht);
                product.liste_prix = [this.preparePriceListsForImport(ht, ttc)];
            } else {
                product.liste_prix = [];
            }
        }

        if (!Array.isArray(product.information_logistique)) {
            const typeNorm = String(product.type || '')
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');
            const isMateriel = typeNorm === 'materiel';
            product.information_logistique = isMateriel ? this.prepareWarehousesForImport(0, 0) : [];
        }

        if (product.autoriser_vente_stock_vide === undefined) {
            product.autoriser_vente_stock_vide = false;
        }
        if (product.produit_avec_numero_serie === undefined) {
            product.produit_avec_numero_serie = false;
        }
    }

    private finalizeImport(importedCount: number, errors: string[], modal: any) {
        if (errors.length > 0) {
            const errorMessage = errors.length > 5 ?
                `${errors.slice(0, 5).join('<br>')}<br>... et ${errors.length - 5} autres erreurs` :
                errors.join('<br>');

            this.toastr.warning(
                errorMessage,
                `${importedCount} produit(s) importé(s) avec ${errors.length} erreur(s)`,
                { enableHtml: true, timeOut: 10000 }
            );
        } else {
            this.toastr.success(`${importedCount} produit(s) importé(s) avec succès`, 'Import réussi');
        }

        this.selectedFile = null;
        if (this.fileInput?.nativeElement) {
            this.fileInput.nativeElement.value = '';
        }
        modal.dismiss('Completed');
    }

    private productArchiveEvent = new Subject<{ product: Product, is_archive: boolean }>();

    emitProductArchiveEvent(product: Product, is_archive: boolean) {
        this.productArchiveEvent.next({ product, is_archive });
    }



    downloadTemplate() {
        try {
            const workbook = createEmptyProductImportWorkbook();
            XLSX.writeFile(workbook, 'produit_template.xlsx');
            this.toastr.success('Modèle téléchargé', 'Succès');
        } catch (error) {
            console.error('Error downloading template:', error);
            this.toastr.error('Erreur lors du téléchargement du modèle', 'Erreur');
        }
    }

    triggerFileInput(event: MouseEvent) {
        event.preventDefault();
        if (this.fileInput?.nativeElement) {
            this.fileInput.nativeElement.click();
        } else {
            this.toastr.error('Erreur d\'accès au sélecteur de fichier', 'Erreur');
        }
    }



    /*  private finalizeImport(importedCount: number, errors: string[], modal: any) {
          if (errors.length > 0) {
              const errorMessage = `${importedCount} produit(s) importé(s) avec ${errors.length} erreur(s).`;

              this.toastr.warning(errorMessage, 'Import partiel');
          } else {
              this.toastr.success(`${importedCount} produit(s) importé(s) avec succès`, 'Succès');
          }

          this.selectedFile = null;
          if (this.fileInput?.nativeElement) {
              this.fileInput.nativeElement.value = '';
          }

          // Refresh products list
          this.loadProducts();

          modal.close('Import completed');
      }*/



    private exportTable(format: string) {
        const data = this.getProductData();

        if (!data || data.length === 0) {
            this.toastr.warning('Aucune donnée disponible pour l\'exportation', 'Avertissement');
            return;
        }

        switch (format) {
            case 'pdf':
                this.exportToPDF(data);
                break;
            case 'csv':
                this.exportToCSV(data);
                break;
            case 'xlsx':
                this.exportToXLSX(data);
                break;
        }
    }

    private getExportContextOrWarn(): { stationId: number; userId: number } | null {
        this.syncSessionContextFromStorage();
        const stationId = Number(this.stationId);
        const userId = Number(this.clientId);
        if (!Number.isFinite(stationId) || stationId <= 0 || !Number.isFinite(userId) || userId <= 0) {
            this.toastr.error('Session invalide : station ou utilisateur introuvable.', 'Export');
            return null;
        }
        return { stationId, userId };
    }

    private getProduitsRefModuleOrWarn(): { tableDbId: number } | null {
        // `ref_data_module.code` côté API = `products` (pas la clé de route « produits »)
        const ref =
            this.paramDonneesState.getModuleRef('products') ?? this.paramDonneesState.getModuleRef('produits');
        if (!ref) {
            this.toastr.error(
                'Module « products » introuvable dans ref_data_module (vérifiez GET /api/parametrage/data-modules).',
                'Export'
            );
            return null;
        }
        const tableDbId = resolveRefModuleTableDbId(ref);
        if (!Number.isFinite(tableDbId) || tableDbId <= 0) {
            this.toastr.error(
                'Identifiant table (table_db_id / id) invalide pour le module « products ».',
                'Export'
            );
            return null;
        }
        return { tableDbId };
    }

    private pickFirstActiveExportFormat(formats: DataExportFormatDto[]): DataExportFormatDto | null {
        if (!Array.isArray(formats) || formats.length === 0) {
            return null;
        }
        const actif = formats.find((f) => (f as any)?.actif === true) ?? null;
        return actif ?? formats[0] ?? null;
    }

    private exportValueForMapping(item: Product, colonneFichier: string): unknown {
        const k = (colonneFichier || '').trim();
        if (!k) {
            return '';
        }
        switch (k) {
            case 'categories_id':
                return this.getCategoryName((item as any).categories_id);
            case 'marque_id':
                return this.getMarqueName((item as any).marque_id);
            case 'tva_id':
                return this.getTvaRate((item as any).tva_id);
            case 'taxe_id':
                return this.getTaxeName((item as any).taxe_id);
            case 'etat_stock':
                return this.getStockStatus((item as any).informations_logistique);
            case 'quantite_min':
                return this.getMinStock((item as any).informations_logistique);
            case 'quantite_max':
                return this.getMaxStock((item as any).informations_logistique);
            case 'prix_vente_ttc':
                return (item as any).liste_prix?.result_ttc ?? (item as any).prix_unitaires ?? 0;
            case 'prix_vente_ht':
                return (item as any).liste_prix?.result_ht ?? 0;
        }

        // Support "a.b.c" (ex: "categorie.libelle")
        const parts = k.split('.').map((p) => p.trim()).filter(Boolean);
        let cur: any = item as any;
        for (const p of parts) {
            if (cur == null) {
                return '';
            }
            cur = cur[p];
        }
        if (cur == null) {
            return '';
        }
        if (typeof cur === 'object') {
            try {
                return JSON.stringify(cur);
            } catch {
                return '';
            }
        }
        return cur;
    }

    private csvEscape(v: unknown): string {
        const s = v == null ? '' : String(v);
        return `"${s.replace(/"/g, '""')}"`;
    }

    private exportDynamicCsvOrXlsx(data: Product[], kind: 'csv' | 'xlsx'): void {
        const ctx = this.getExportContextOrWarn();
        if (!ctx) {
            return;
        }

        // Charge ref_data_module (pour table_db_id), puis formats, puis mappings.
        const sub = this.paramDonneesState
            .ensureRefModules()
            .pipe(
                map(() => this.getProduitsRefModuleOrWarn()),
                switchMap((ref) => {
                    if (!ref) {
                        return of(null as { tableDbId: number } | null);
                    }
                    return of(ref);
                }),
                switchMap((ref) => {
                    if (!ref) {
                        return of({ fmt: null as DataExportFormatDto | null, mappings: [] as DataExportMappingDto[] });
                    }
                    return this.paramDonneesApi
                        .getDataExportFormatsByTable(ref.tableDbId, ctx.stationId, ctx.userId)
                        .pipe(
                            map((formats) => this.pickFirstActiveExportFormat(formats)),
                            switchMap((fmt) => {
                                const exportFormatId = Number((fmt as any)?.id);
                                if (!fmt || !Number.isFinite(exportFormatId) || exportFormatId <= 0) {
                                    return of({ fmt: null as DataExportFormatDto | null, mappings: [] as DataExportMappingDto[] });
                                }
                                return this.paramDonneesApi
                                    .getDataExportMappingsByExportFormat(exportFormatId, ctx.stationId, ctx.userId)
                                    .pipe(map((mappings) => ({ fmt, mappings })));
                            }),
                            catchError(() => of({ fmt: null as DataExportFormatDto | null, mappings: [] as DataExportMappingDto[] }))
                        );
                }),
                take(1)
            )
            .subscribe({
                next: ({ fmt, mappings }) => {
                    const rows = Array.isArray(mappings) ? [...mappings] : [];
                    const sorted = rows.sort((a, b) => Number((a as any).ordre ?? 0) - Number((b as any).ordre ?? 0));

                    // Si aucun mapping, fallback sur l’export statique existant.
                    if (sorted.length === 0) {
                        if (kind === 'csv') {
                            this.exportToCSVStatic(data);
                        } else {
                            this.exportToXLSXStatic(data);
                        }
                        return;
                    }

                    const cols = sorted
                        .map((m) => ({
                            header: String((m as any).champ_source ?? (m as any).colonne_fichier ?? '').trim(),
                            key: String((m as any).colonne_fichier ?? '').trim()
                        }))
                        .filter((c) => c.header && c.key);

                    if (cols.length === 0) {
                        if (kind === 'csv') {
                            this.exportToCSVStatic(data);
                        } else {
                            this.exportToXLSXStatic(data);
                        }
                        return;
                    }

                    const suffix = fmt?.nom ? String(fmt.nom).trim().replace(/\s+/g, '_') : 'export';
                    const date = new Date().toISOString().split('T')[0];

                    if (kind === 'csv') {
                        const headerLine = cols.map((c) => this.csvEscape(c.header)).join(',');
                        const bodyLines = data.map((item) =>
                            cols.map((c) => this.csvEscape(this.exportValueForMapping(item, c.key))).join(',')
                        );
                        const csvContent = [headerLine, ...bodyLines].join('\n');
                        const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
                        const link = document.createElement('a');
                        const url = URL.createObjectURL(blob);
                        link.setAttribute('href', url);
                        link.setAttribute('download', `produits_${suffix}_${date}.csv`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        this.toastr.success('Exportation CSV réussie', 'Succès');
                        return;
                    }

                    const worksheetData = data.map((item) => {
                        const o: Record<string, unknown> = {};
                        for (const c of cols) {
                            o[c.header] = this.exportValueForMapping(item, c.key);
                        }
                        return o;
                    });
                    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'Produits');
                    XLSX.writeFile(workbook, `produits_${suffix}_${date}.xlsx`);
                    this.toastr.success('Exportation XLSX réussie', 'Succès');
                },
                error: () => {
                    if (kind === 'csv') {
                        this.exportToCSVStatic(data);
                    } else {
                        this.exportToXLSXStatic(data);
                    }
                }
            });

        this.subscriptions.push(sub);
    }

    private exportDynamicCsvOrXlsxByFormat(
        data: Product[],
        kind: 'csv' | 'xlsx',
        exportFormatId: number,
        fmtLabel: string
    ): void {
        const ctx = this.getExportContextOrWarn();
        if (!ctx) {
            return;
        }
        const exportFormatIdNum = Number(exportFormatId);
        if (!Number.isFinite(exportFormatIdNum) || exportFormatIdNum <= 0) {
            this.toastr.error('Modèle d’export invalide.', 'Export');
            return;
        }

        const sub = this.paramDonneesState
            .ensureRefModules()
            .pipe(
                map(() => this.getProduitsRefModuleOrWarn()),
                switchMap((ref) => {
                    if (!ref) {
                        return of([] as DataExportMappingDto[]);
                    }
                    return this.paramDonneesApi
                        .getDataExportMappingsByExportFormat(exportFormatIdNum, ctx.stationId, ctx.userId)
                        .pipe(catchError(() => of([] as DataExportMappingDto[])));
                }),
                take(1)
            )
            .subscribe({
                next: (mappings) => {
                    const rows = Array.isArray(mappings) ? [...mappings] : [];
                    const sorted = rows.sort((a, b) => Number((a as any).ordre ?? 0) - Number((b as any).ordre ?? 0));

                    if (sorted.length === 0) {
                        if (kind === 'csv') {
                            this.exportToCSVStatic(data);
                        } else {
                            this.exportToXLSXStatic(data);
                        }
                        return;
                    }

                    const cols = sorted
                        .map((m) => ({
                            header: String((m as any).champ_source ?? (m as any).colonne_fichier ?? '').trim(),
                            key: String((m as any).colonne_fichier ?? '').trim()
                        }))
                        .filter((c) => c.header && c.key);

                    if (cols.length === 0) {
                        if (kind === 'csv') {
                            this.exportToCSVStatic(data);
                        } else {
                            this.exportToXLSXStatic(data);
                        }
                        return;
                    }

                    const suffix = fmtLabel ? String(fmtLabel).trim().replace(/\s+/g, '_') : 'export';
                    const date = new Date().toISOString().split('T')[0];

                    if (kind === 'csv') {
                        const headerLine = cols.map((c) => this.csvEscape(c.header)).join(',');
                        const bodyLines = data.map((item) =>
                            cols.map((c) => this.csvEscape(this.exportValueForMapping(item, c.key))).join(',')
                        );
                        const csvContent = [headerLine, ...bodyLines].join('\n');
                        const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
                        const link = document.createElement('a');
                        const url = URL.createObjectURL(blob);
                        link.setAttribute('href', url);
                        link.setAttribute('download', `produits_${suffix}_${date}.csv`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        this.toastr.success('Exportation CSV réussie', 'Succès');
                        return;
                    }

                    const worksheetData = data.map((item) => {
                        const o: Record<string, unknown> = {};
                        for (const c of cols) {
                            o[c.header] = this.exportValueForMapping(item, c.key);
                        }
                        return o;
                    });
                    const worksheet = XLSX.utils.json_to_sheet(worksheetData);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'Produits');
                    XLSX.writeFile(workbook, `produits_${suffix}_${date}.xlsx`);
                    this.toastr.success('Exportation XLSX réussie', 'Succès');
                },
                error: () => {
                    if (kind === 'csv') {
                        this.exportToCSVStatic(data);
                    } else {
                        this.exportToXLSXStatic(data);
                    }
                }
            });

        this.subscriptions.push(sub);
    }

    private exportToPDF(data: Product[]) {
        try {


            if (!data || data.length === 0) {
                this.toastr.warning('Aucune donnée à exporter', 'Avertissement');
                return;
            }

            const doc = new jsPDF();

            // Add title and date
            doc.setFontSize(16);
            doc.text('LISTE DES PRODUITS', 14, 15);
            doc.setFontSize(10);
            doc.text(`Généré le: ${new Date().toLocaleDateString('fr-FR')}`, 14, 22);
            doc.text(`Total des produits: ${data.length}`, 14, 29);

            // Prepare table data
            const headers = [
                ['RÉFÉRENCE', 'NOM / CATÉGORIES / MARQUE', 'PRIX DE VENTE', 'ÉTAT EN STOCK', 'TVA', 'TAXES']
            ];

            const tableData = data.map(item => [
                item.ref_interne || item.ref_fabricant || '---',
                this.formatProductInfo(item),
                this.formatPrice(item),
                this.getStockStatus(item.informations_logistique),
                this.formatTVA(item.tva_id),
                this.getTaxeName(item.taxe_id) || '---'
            ]);



            // Generate table using autoTable
            autoTable(doc, {
                head: headers,
                body: tableData,
                startY: 35,
                theme: 'grid',
                headStyles: {
                    fillColor: [19, 74, 211],
                    textColor: 255,
                    fontStyle: 'bold',
                    fontSize: 9
                },
                styles: {
                    fontSize: 7,
                    cellPadding: 2,
                    lineColor: [0, 0, 0],
                    lineWidth: 0.1
                },
                columnStyles: {
                    0: { cellWidth: 20, fontStyle: 'bold' },
                    1: { cellWidth: 45 },
                    2: { cellWidth: 20, halign: 'right' },
                    3: { cellWidth: 25, fontSize: 6 },
                    4: { cellWidth: 15, halign: 'center' },
                    5: { cellWidth: 25 }
                },
                margin: { top: 35 },
                pageBreak: 'auto',
                rowPageBreak: 'avoid',
                tableWidth: 'wrap'
            });

            // Add page numbers if multiple pages
            const pageCount = (doc as any).internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.setFontSize(8);
                doc.text(`Page ${i} / ${pageCount}`, doc.internal.pageSize.width - 25, doc.internal.pageSize.height - 10);
            }

            doc.save(`produits_${new Date().toISOString().split('T')[0]}.pdf`);
            this.toastr.success('Exportation PDF réussie', 'Succès');

        } catch (error) {

            this.toastr.error('Erreur lors de l\'exportation PDF', 'Erreur');
        }
    }

// Fixed formatPrice method with proper type checking
    private formatPrice(item: Product): string {
        try {
            // Check if liste_prix exists and has result_ttc
            let price: number = 0;

            if (item.liste_prix?.result_ttc !== undefined && item.liste_prix?.result_ttc !== null) {
                price = Number(item.liste_prix.result_ttc);
            } else if (item.prix_unitaires !== undefined && item.prix_unitaires !== null) {
                price = Number(item.prix_unitaires);
            }

            // Validate that price is a valid number
            if (isNaN(price)) {
                console.warn('Invalid price found for product:', item.ref_interne, 'Price value:', item.liste_prix?.result_ttc, item.prix_unitaires);
                return '0.00 TND';
            }

            return `${price.toFixed(2)} TND`;
        } catch (error) {

            return '0.00 TND';
        }
    }


// Helper methods for formatting
    private formatProductInfo(item: Product): string {
        const nom = item.nom || 'Sans nom';
        const categorie = this.getCategoryName(item.categories_id) || '---';
        const marque = this.getMarqueName(item.marque_id) || '---';
        return `${nom} / ${categorie} / ${marque}`;
    }

    private formatTVA(tvaId: number): string {
        const tvaRate = this.getTvaRate(tvaId);
        return tvaRate ? `${tvaRate}%` : '0%';
    }

    private getStockStatus(logistique: any[]): string {
        if (!logistique || logistique.length === 0) return 'Non configuré';

        const mainLog = logistique[0];
        if (mainLog.minimum === undefined || mainLog.maximum === undefined) return 'Non configuré';

        const min = mainLog.minimum || 0;
        const max = mainLog.maximum || 0;

        return `Min: ${min}\nMax: ${max}`;
    }

// Make sure these helper methods are implemented
    private getCategoryName(categoryId: number | null | undefined): string {
        if (categoryId == null) return '';

        const cat = (this.categories ?? []).find(
            (c: any) => c?.id === categoryId
        );

        return cat?.libelle ?? '';
    }


    private getMarqueName(marqueId: number | null | undefined): string {
        if (marqueId == null) return '';

        const m = (this.marques ?? []).find(x => x?.id === marqueId);

        return m?.libelle ?? '';
    }


    private getTvaRate(tvaId: number | null | undefined): number {
        if (tvaId == null) return 0;

        const tva = (this.tvas ?? []).find(t => t?.id === tvaId);

        return Number(tva?.valeur ?? 0);
    }


    private getTaxeName(taxeId: number | number[] | null | undefined): string {
        if (taxeId == null) return '';

        // Case: taxeId is a list
        if (Array.isArray(taxeId)) {
            return taxeId
                .map(id => this.getTaxeName(id)) // recursion for each item
                .filter(x => x)                  // remove empty strings
                .join(', ');
        }

        // Case: taxeId is a single number
        const taxe = (this.taxes ?? []).find(t => t?.id === taxeId);

        return taxe?.nom ?? taxe?.label ?? '---';
    }







    private exportToCSV(data: Product[]) {
        try {
            // Export dynamique via mapping (si disponible), fallback sur colonnes statiques si mapping absent.
            this.exportDynamicCsvOrXlsx(data, 'csv');
        } catch (error) {
            console.error('exportToCSV: Error=', JSON.stringify(error, null, 2));
            this.toastr.error('Erreur lors de l\'exportation CSV', 'Erreur');
        }
    }

    private exportToCSVStatic(data: Product[]) {
        const headers = [
            'RÉFÉRENCE INTERNE,RÉFÉRENCE FABRICANT,CODE BARRE,NOM,CATÉGORIE,MARQUE,PRIX DE VENTE TTC,PRIX DE VENTE HT,ÉTAT EN STOCK,QUANTITÉ MIN,QUANTITÉ MAX,TVA,TAXE,TYPE PRODUIT'
        ];
        const rows = data.map((item) =>
            `"${item.ref_interne || ''}","${item.ref_fabricant || ''}","${(item as any).code_barre || ''}","${item.nom || ''}","${this.getCategoryName(item.categories_id) || ''}","${this.getMarqueName(item.marque_id) || ''}","${item.liste_prix?.result_ttc || item.prix_unitaires || 0}","${item.liste_prix?.result_ht || 0}","${this.getStockStatus(item.informations_logistique)}","${this.getMinStock(item.informations_logistique)}","${this.getMaxStock(item.informations_logistique)}","${this.getTvaRate(item.tva_id) || 0}","${this.getTaxeName(item.taxe_id) || ''}","${item.type || ''}"`
        );
        const csvContent = headers.concat(rows).join('\n');
        const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'produits.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.toastr.success('Exportation CSV réussie', 'Succès');
    }

    private exportToXLSX(data: Product[]) {
        try {
            // Export dynamique via mapping (si disponible), fallback sur colonnes statiques si mapping absent.
            this.exportDynamicCsvOrXlsx(data, 'xlsx');
        } catch (error) {
            this.toastr.error('Erreur lors de l\'exportation XLSX', 'Erreur');
            //   console.error('exportToXLSX: Error=', JSON.stringify(error, null, 2));
        }
    }

    private exportToXLSXStatic(data: Product[]) {
        const worksheetData = data.map((item) => ({
            'RÉFÉRENCE INTERNE': item.ref_interne || '',
            'RÉFÉRENCE FABRICANT': item.ref_fabricant || '',
            'CODE BARRE': (item as any).code_barre || '',
            'NOM': item.nom || '',
            'CATÉGORIE': this.getCategoryName(item.categories_id) || '',
            'MARQUE': this.getMarqueName(item.marque_id) || '',
            'PRIX DE VENTE TTC': item.liste_prix?.result_ttc || item.prix_unitaires || 0,
            'PRIX DE VENTE HT': item.liste_prix?.result_ht || 0,
            'ÉTAT EN STOCK': this.getStockStatus(item.informations_logistique),
            'QUANTITÉ MINIMUM': this.getMinStock(item.informations_logistique),
            'QUANTITÉ MAXIMUM': this.getMaxStock(item.informations_logistique),
            'TVA (%)': this.getTvaRate(item.tva_id) || 0,
            'TAXE': this.getTaxeName(item.taxe_id) || '',
            'TYPE PRODUIT': item.type || '',
            'DESCRIPTION': item.description || '',
            'ARCHIVÉ': item.is_archive ? 'Oui' : 'Non'
        }));
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Produits');
        XLSX.writeFile(workbook, 'produits.xlsx');
        this.toastr.success('Exportation XLSX réussie', 'Succès');
    }


    private getMinStock(logistique: any[]): number {
        return logistique && logistique.length > 0 ? logistique[0].minimum || 0 : 0;
    }

    private getMaxStock(logistique: any[]): number {
        return logistique && logistique.length > 0 ? logistique[0].maximum || 0 : 0;
    }



    openImportModal() {
        this.syncSessionContextFromStorage();
        this.selectedFile = null;
        this.importPreviewBusy = false;
        this.importConfirmBusy = false;
        this.importPreviewGroups = [];
        this.importPreviewTotalLines = 0;
        this.importPreviewErrorCount = 0;
        this.importPreviewValidCount = 0;
        this.modalService.open(this.importModal, {
            centered: true,
            backdrop: 'static',
            size: 'xl',
            windowClass: 'products-import-modal-window'
        });
        setTimeout(() => feather.replace(), 0);
    }
    onFileSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            this.selectedFile = input.files[0];

            if (this.selectedFile.size > ProductsComponent.IMPORT_MAX_BYTES) {
                this.toastr.error('Fichier trop volumineux (max 50 Mo)', 'Erreur');
                this.selectedFile = null;
                input.value = '';
            } else if (!this.selectedFile.name.toLowerCase().endsWith('.xlsx')) {
                this.toastr.error('Seuls les fichiers .xlsx sont autorisés', 'Erreur');
                this.selectedFile = null;
                input.value = '';
            } else {
                this.toastr.success('Fichier sélectionné avec succès', 'Succès');
            }
        }
    }
    products: any[] = [];

    private loadProducts(page: number = 1, limit: number = 1000, isArchive: boolean = false): void {
        this.productService.getProductsByStationId(this.stationId, page, limit, isArchive)
            .subscribe({
                next: (response: PaginatedResponse<Product>) => {
                    this.products = response.data  || [];
                    this.categories = this.products.map(c => c.categorie);
                    this.marques = this.products.map(c => c.marque);
                    this.tvas = this.products.map(c => c.tva);
                    this.taxes = this.products.map(c => c.taxe);
                   // console.log('noms produits', this.products.map(c => c.categorie?.libelle));

                    this.cd.markForCheck();
                },
                error: (error) => {

                    this.toastr.error('Erreur lors du chargement des produits', 'Erreur');
                }
            });
    }
    private getProductData(): Product[] {
        return this.products;
    }

}
